const CSRF_STORAGE_KEY = "csrf_token";

function readCookie(name) {
  if (typeof document === "undefined") return "";
  const prefix = `${name}=`;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const value = part.trim();
    if (value.startsWith(prefix)) {
      return decodeURIComponent(value.slice(prefix.length));
    }
  }
  return "";
}

export function getCsrfToken() {
  const fromCookie = readCookie("csrf_access_token");
  if (fromCookie) return fromCookie;
  try {
    return sessionStorage.getItem(CSRF_STORAGE_KEY) || "";
  } catch (_err) {
    return "";
  }
}

export function setCsrfToken(token) {
  try {
    if (token) {
      sessionStorage.setItem(CSRF_STORAGE_KEY, token);
    } else {
      sessionStorage.removeItem(CSRF_STORAGE_KEY);
    }
  } catch (_err) {
    // Ignore storage failures (private mode).
  }
}

export function csrfHeaders(extra = {}) {
  const headers = { ...extra };
  const token = getCsrfToken();
  if (token) {
    headers["X-CSRF-TOKEN"] = token;
  }
  return headers;
}
